export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12404.23ee86df.jpg";